<template>
    <v-app>
        <v-main>
            <v-container fill-height>
                <v-row class="text-center">
                    <v-col>
                        <div class="d-flex flex-column">
                            <v-icon color="warning" size="70" class="mb-2">mdi-alert</v-icon>
                            <p class="text-h4">Page Not Found</p>
                            <p class="text-subtitle-1">Sorry, but the page you are looking for doesn't exist.</p>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
export default {

}
</script>

<style>

</style>